import Select2Controller from "./select2_controller";

export default class extends Select2Controller {
  getDefaultParams() {
    return {
      ...super.getDefaultParams(),
      templateResult: this.setColor,
      templateSelection: this.setColor,
    };
  }

  setColor(item) {
    if (!item.id) {
      return item.text;
    }

    const $container = $("<div>").addClass("d-flex align-items-center");

    $("<div>")
      .css({
        backgroundColor: item.element.dataset.hex,
        width: "15px",
        height: "15px",
        marginRight: "5px",
      })
      .appendTo($container);

    $("<div>").text(item.text).appendTo($container);

    return $container;
  }
}
